module.exports = __webpack_public_path__ + "img/nl.61aea439.svg";